import axios from 'axios'
import qs from 'qs';

/**
 * 配置项
 */


//是否正式环境
const isOfficial = true


const asyncTestUrl = {
  //base.url请求
   apiUrl: "http://192.168.0.36:9105",
  
  //图片地址
  picUrl: "http://192.168.0.36:9105", 
}

const asyncOfficialUrl = {
  //base.url请求
  apiUrl: "http://tak-test.wahlap.net/api",
  mpUrl: "https://tak-test.wahlap.net/mp/",
  
  //图片地址
  picUrl: "https://tak-test.wahlap.net/mp/", 
}

const asyncBaseURL = isOfficial?asyncOfficialUrl:asyncTestUrl
const instance = axios.create({
  baseURL:asyncBaseURL.apiUrl,
  withCredentials:true,// 跨域 cookie
  timeout: 15000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  }
})
const request = {}
/*
const methods = ['post', 'put', 'patch', 'delete', 'get', 'head']
*/

request['post'] = (url, params, headers) => {
  return instance.post(url, qs.stringify(params), {headers}).then(res => {
    return res
  }).catch(async e => {
    throw e
  })
}

request['get'] = (url, params, headers) => {
  return instance.get(url, {params,headers}).then(res => {
    return res
  }).catch(async e => {
     throw e
  })
}

/** 
 * response 拦截器-每次数据请求都会触发
 */
instance.interceptors.response.use(
    response => {
      if(response.data.ok){
        return response.data
      }else{
        alert(response.data.message) 
      }
    },
    error => {
      if (error.response) {
        throw error;
      }
      return Promise.reject(error)   // 返回接口返回的错误信息
    });


export default request
